export const AppSteps = {
    hero: {
        cls: 'index-page',
        title: 'Your Offer',
        comp: 'Hero'
    },
    newOffer: {
        cls: 'index-page',
        title: 'Start Your Application',
        comp: 'NewOffer'
    },
    notAccepting: {
        cls: 'index-page',
        title: 'Applications Closed',
        comp: 'NotAccepting'
    },
    pin: {
        cls: 'index-page',
        title: 'Find Your Offer',
        comp: 'Pin'
    },
    finalReview: {
        cls: 'final-review-page',
        title: 'Review Information',
        subtitle: 'Let\'s just review the information!',
        comp: 'FinalReview'
    },
    finalQuestions: {
        cls: 'final-review-page final-questions',
        title: 'Add Co-applicant',
        comp: 'FinalQuestions'
    },
    submit: {
        cls: 'final-review-page submit',
        title: 'Submit Application',
        comp: 'Submit'
    },
    congrats: {
        cls: 'final-review-page',
        title: 'Application Submitted',
        comp: 'Congrats'
    },
    addCoApp: {
        cls: 'final-review-page',
        title: 'Add Co-Applicant',
        comp: 'AddCoApp'
    },
    verifyAccountCCR: {
        title: 'CCR Login',
        cls: 'verify-authentication-page ccr',
        comp: 'VerifyAccountCCR'
    },
    validationInfo: {
        title: 'Authentication',
        cls: 'verify-authentication-page',
        comp: 'ValidationInfo'
    },
    verifyDob: {
        title: 'Authentication',
        cls: 'verify-authentication-page',
        comp: 'VerifyDob'
    },
    verifySSN: {
        title: 'Authentication',
        cls: 'verify-authentication-page',
        comp: 'VerifySSN'
    },
    verifyAccount: {
        title: 'Authentication',
        cls: 'verify-authentication-page',
        comp: 'VerifyAccount'
    },
    verifyAddress: {
        title: 'Authentication',
        cls: 'verify-authentication-page',
        comp: 'VerifyAddress'
    },
    buyerInfo: {
        title: 'Applicant Information',
        subtitle: 'Step 1 of %nSteps% - Applicant',
        stepTitle: 'Applicant Info',
        cls: 'buyer-information-page',
        comp: 'BuyerInfo'
    },
    vehicleInfo: {
        title: 'Vehicle Information',
        subtitle: 'Step 2 of %nSteps% - Car Associated with this Loan',
        stepTitle: 'Vehicle Info',
        cls: 'vehicle-information-page',
        comp: 'VehicleInfo'
    },
    employmentInfo: {
        title: 'Employment Info',
        subtitle: 'Step %nStep% of %nSteps% - Where do you work?',
        stepTitle: 'Employment Info',
        cls: 'employment-information-page',
        comp: 'EmploymentInfo'
    },
    additionalIncome: {
        title: 'Employment Info',
        subtitle: 'Step %nStep% of %nSteps% - Additional income',
        stepTitle: 'Employment Info',
        cls: 'additional-income-page',
        comp: 'AdditionalIncome'
    },
    callback: {
        title: 'Call Me',
        cls: 'callback-page',
        comp: 'Callback'
    },
    documents: {
        title: 'Your Documents',
        cls: 'documents-page',
        comp: 'Documents'
    },
    stips: {
        title: 'Upload Documents',
        cls: 'stips-page',
        comp: 'StipsList'
    },
    stipEdit: {
        title: 'Edit Document',
        cls: 'stips-page',
        comp: 'StipEdit'
    },
    stipsStatus: {
        title: 'Document Statuses',
        cls: 'stips-page',
        comp: 'StipsStatus'
    },
    stipsWelcome: {
        title: 'Documents Welcome',
        cls: 'stips-page',
        comp: 'StipsWelcome'
    },
    stipResubmit: {
        title: 'Resubmit Documents',
        cls: 'stips-page',
        comp: 'StipsResubmit'
    },
    stipsSubmitted: {
        title: 'Documents Submitted',
        cls: 'stips-page',
        comp: 'StipsSubmitted'
    },
    citizenship: {
        title: 'US Citizenship',
        cls: 'us-citizenship',
        comp: 'Citizenship'
    },
    priorMembership: {
        title: 'Prior Membership',
        cls: 'prior-membership',
        comp: 'PriorMembership'
    },
    reveal:  {
        title: 'Reveal your Savings',
        cls: 'reveal-page',
        comp: 'Reveal'
    },
    segment:  {
        title: 'Find your Deal',
        cls: 'segment-page',
        comp: 'Segment'
    }
};
